import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-bda4fde2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "hello"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "blank"
}, null, -1));

const _hoisted_3 = {
  class: "title-main"
};
const _hoisted_4 = ["src"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "left",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.back && $setup.back(...args))
  }, [_createElementVNode("img", {
    src: $setup.Left,
    class: "left-icon"
  }, null, 8, _hoisted_4)]), _createTextVNode(" " + _toDisplayString($props.title) + " ", 1), _hoisted_5])]);
}